import React from "react";
import Button from "@mui/material/Button";
import { Box } from "@mui/system";
import { Divider, Typography, useMediaQuery } from "@mui/material";
import arrow from "../../Assets/Images/Arrow 3.png";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { styles } from "./styles";
import { Header } from "../OurMission/styles";
import paths from "../../Infrastructure/Router/paths";

const HowItWorks = () => {
  const isSmallScreen = useMediaQuery("(min-width: 899px)");
  const navigate = useNavigate();

  const navigateToEdu = () => {
    navigate(paths.educatorFaq.path);
  };
  const navigateToLearn = () => {
    navigate(paths.learnerFaq.path);
  };
  return (
    <Box sx={styles.containerBox}>
      <Grid container alignContent="center" alignItems="center">
        <Grid lg={12} xs={12}>
          <Header sx={styles.heading}>
            How the Vulcan Learning platform works
          </Header>
        </Grid>
        <Grid lg={9}>
          <Typography
            color="black"
            align="left"
            sx={styles.description}
          >
            Our service connects Learners with Educators offering live
            educational classes on a wide range of subjects. Here's how it
            works:
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Grid lg={5} md={5} sm={12} xs={12} sx={styles.gridPadding}>
          <Grid lg={12}>
            <Box>
              <Typography variant="h1" color="black" align="center" sx={styles.learnerTitle}>
                Learner
              </Typography>
              <Typography variant="h5" color="primary" align="left" mt={10} sx={styles.learnerStepTitle}>
                1. Find a course
              </Typography>
              <Typography variant="body3" color="black" align="left">
                Explore our courses and pick one you want to take.
              </Typography>
              <Box sx={styles.arrowBoxLarge}>
                <img src={arrow} alt="arrow" />
              </Box>
            </Box>
          </Grid>
          <Grid lg={12}>
            <Box>
              <Typography variant="h5" color="primary" align="left">
                2. Decide if it's right for you
              </Typography>
              <Typography variant="body3" color="black" align="left">
                Check the course curriculum, class schedule, <br /> instructor
                profile, and learner reviews to verify that <br /> the course is
                the right it for you.
              </Typography>
              <Box sx={styles.arrowBox}>
                <img src={arrow} alt="arrow" />
              </Box>
            </Box>
          </Grid>{" "}
          <Grid lg={12}>
            <Box>
              <Typography variant="h5" color="primary" align="left">
                3. Complete Enrollment
              </Typography>
              <Typography variant="body3" color="black" align="left">
                Choose among the available class schedules, and <br /> click on
                enroll. No application required. All you <br /> need to complete
                enrollment is successfully <br />
                checkout.
              </Typography>
            </Box>
          </Grid>
          <Grid lg={12}>
            <Box>
              <Box sx={styles.learnerFaqButtonBox}>
                <Button
                  onClick={navigateToLearn}
                  variant="contained"
                  size="small"
                  style={{ textTransform: "capitalize" }}
                >
                  Learner FAQ
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Grid
          lg={1}
          md={1}
          direction="column"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Box sx={styles.dividerWrapper}>
            {isSmallScreen && (
              <Divider orientation="horizontal" sx={styles.divider} />
            )}
          </Box>
        </Grid>

        <Grid lg={5} md={5} sm={12} xs={12} sx={styles.gridPadding}>
          <Grid lg={12}>
            <Box>
              <Typography variant="h1" color="black" align="center" sx={styles.learnerTitle}>
                Educators
              </Typography>
              <Typography variant="h5" color="primary" align="left" sx={styles.learnerStepTitle}>
                1. Create your course
              </Typography>
              <Typography variant="body3" color="black" align="left">
                Set up an Educator account and create the course <br />
                that you want to offer.{" "}
              </Typography>
              <Box sx={styles.arrowBox}>
                <img src={arrow} alt="arrow" />
              </Box>
            </Box>
          </Grid>
          <Grid lg={12}>
            <Box>
              <Typography variant="h5" color="primary" align="left">
                2. Submit for approval
              </Typography>
              <Typography variant="body3" color="black" align="left">
                Meet all the requirements and submit your course <br />
                for review. We will review your course application <br />
                thoroughly and get back to you with a decision.
              </Typography>
              <Box sx={styles.arrowBox}>
                <img src={arrow} alt="arrow" />
              </Box>
            </Box>
          </Grid>
          <Grid lg={12}>
            <Box>
              <Typography variant="h5" color="primary" align="left">
                3. Make your courses available
              </Typography>
              <Typography variant="body3" color="black" align="left">
                {" "}
                Finalize the class schedule and curriculum, pick <br />
                the start date, and publish your course.
                <br />{" "}
              </Typography>
            </Box>
          </Grid>
          <Grid lg={12}>
            <Box>
              <Box sx={styles.educatorFaqButtonBox}>
                <Button
                  onClick={navigateToEdu}
                  variant="contained"
                  size="small"
                  style={{ textTransform: "capitalize" }}
                >
                  Educator FAQ
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HowItWorks;